import styled from 'styled-components';

const AdminSecretsShowWrap = styled.div`
  display: flex;
  flex: 1;
`;

export default AdminSecretsShowWrap;
